<template>
  <div id="tabs">
    <ul>
      <li><a href="#tabs-pedido">Pedidos</a></li>
      <li><a href="#tabs-all">Solicitações</a></li>
      <li><a href="#tabs-tecnicas">Solicitações Técnicas (CO e CE)</a></li>
    </ul>

    <div class="row">
      <div class="col-md-12" id="tabs-pedido">
        <dt-pedidos :emailGroups="emailGroups" :wppGroups="wppGroups" :autoOpenProtocol="deepLinkTab === 'pedido' ? deepLinkProtocol : null"/>
      </div>

      <div class="col-md-12" id="tabs-all">
        <dt-solicitacoes :emailGroups="emailGroups" :wppGroups="wppGroups" :autoOpenProtocol="deepLinkTab === 'solicitacao' ? deepLinkProtocol : null"/>
      </div>

      <div class="col-md-12" id="tabs-tecnicas">
        <dt-tecnicas :autoOpenProtocol="deepLinkTab === 'tecnicas' ? deepLinkProtocol : null"/>
      </div>
    </div>

  </div>

</template>
<script>
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

export default {
    data() {
      return {
        showColaboradoresTab: false,
        emailGroups: [],
        wppGroups: [],
        deepLinkProtocol: null,
        deepLinkTab: null
      }
    },
    created() {
      const params = new URLSearchParams(window.location.search);
      const protocol = params.get('protocol');
      const tab = params.get('tab');
      if (protocol) {
        this.deepLinkProtocol = protocol;
        this.deepLinkTab = ['pedido', 'tecnicas'].includes(tab) ? tab : 'solicitacao';
      }
    },
    async mounted(){
      if(user.getAccessLevel() === 'admin'){
        this.showColaboradoresTab = true
      }
      await this.getEmailGroups();
      await this.getWppGroups();
    
      if (this.deepLinkTab) {
        const tabIndex = { pedido: 0, solicitacao: 1, tecnicas: 2 }[this.deepLinkTab];
        setTimeout(() => {
          $('#tabs').tabs('option', 'active', tabIndex);
        }, 1);
      }
    },
    methods: {
      async getEmailGroups(){
        this.emailGroups = await axios.get('/solicitacoes/contacts/groups/type/email').then(({data}) => {return data})
      },

      async getWppGroups(){
        this.wppGroups = await axios.get('/solicitacoes/contacts/groups/type/whatsapp').then(({data}) => {return data})
      }
    }
}
</script>

<style scoped lang="scss">
    .custom-input-group {
        display: flex;
        height: 5em;
        justify-content: center;
        align-items: center;
    }
    .filter-select-group {
        display: flex;
        flex-direction: row;
        padding: 10px;
    }
    .filter-select-group input {
        height: 1.5em;
        width: 2em;
        margin: 0px;
        padding: 10px;
    }
    .filter-select-group input:focus {
        box-shadow: none;
    }
    .filter-select-group label {
        margin: 0px;
        font-size: 12px;
        align-self: center;
    }
    .filter-group {
        display: flex;
        flex-direction: column;
        margin: 0px;
    }
    .filter-group input {
        width: 70%;
        margin: 5px;
    }
    .filter-group input[type='date'] {
        width: 100%;
        margin: 0;
    }
    .filter-group button {
        margin: 5px;
        height: 2.5em;
        border-radius: 5px !important;
    }
    .filter-select-label {
        font-weight: bold;
        font-size: 18px;
        align-self: center
    }
    #filter-select-container {
        border-right: 2px solid lightgray;
    }
    #history-container {
        margin: 10px;
    }
    #view-button {
        background: none;
        border: none;
        padding: 0;
        box-shadow: none;
        outline: none;
    }
    #view-button i {
        color: #1c869a;
        font-size: 22px;
    }
    #view-button i:hover {
        color: #31bdda;
        transition: 0.5s;
    }

    .not-allowed {
      display: flex;
      flex-direction: column;
      text-align: center;
      margin: 10px;
      gap: 5px;

      span {
        height: 50px;
        font-size: xxx-large;
        color: goldenrod;
      }
    }

</style>